/**
 * Created by 郜凯之 on 2017/9/13
 */
"use strict";
angular.module('editOutSendingDelModule',[])
    .controller("editOutSendingDelCtrl",["$scope","$modalInstance","$validation","params","modalDialog",function($scope,$modalInstance,$validation,params,modalDialog){
        $scope.name=params.EMAILDESC;
        //关闭窗口        
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $modalInstance.close(
                    params
                );
        };
    }]);